<template>
  <component
    :is="component"

    :position="position"
    :hide-after-milliseconds="hideAfterMilliseconds"
    :default-open="defaultOpen"
    :click-outside="clickOutside"
    :buttonText="buttonText"
    :sidebar-width="sidebarWidth"
  >
    <template slot="main">
      <slot name="main" />
    </template>
    <template slot="sidebar">
      <slot name="sidebar" />
    </template>
  </component>
</template>

<script>
export default {
  name: 'HiddenContainer',

  props: {
    /**
     * Should the sidebar `push` or `overlay` the content
     */
    type: {
      type: String,
      required: false,
      default: 'overlay',
      validator: (value) => ['push', 'overlay'].includes(value),
    },

    /**
     * To which side is the container positioned<br />
     * `left` or `right`
     */
    position: {
      type: String,
      required: false,
      default: 'right',
      validator: (value) => ['right', 'left'].includes(value),
    },

    /**
     * Hide the container after amount of milliseconds
     */
    hideAfterMilliseconds: {
      type: Number,
      required: false,
      default: 0,
    },

    /**
     * Should the container remain open when visiting the page
     */
    defaultOpen: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Hide container on click outside
     */
    clickOutside: {
      type: Boolean,
      required: false,
      default: true,
    },

    /**
     * The text in the toggle button to open the container
     */
    buttonText: {
      type: String,
      required: false,
      default: 'Bekijk de content',
    },

    /**
     * The width of the sidebar
     */
    sidebarWidth: {
      type: String,
      required: false,
      default: '700px',
    },
  },

  computed: {
    component() {
      if (this.type === 'push') {
        return 'hidden-container-push';
      }

      return 'hidden-container-overlay';
    },
  },
};
</script>
